import React from 'react';
import { useNavigate } from 'react-router-dom';

const Updates = () => {
  const navigate = useNavigate();

  const updates = [
    {
      date: 'Aug 2026',
      title: 'Suggestions Inbox',
      items: ['New "Suggestions" button in the home-page header lets any customer leave feedback, ideas or complaints without an account. Admin sees them in a new pink Suggestions button on the dashboard with an unread badge that refreshes every 30 seconds.']
    },
    {
      date: 'Aug 2026',
      title: 'Announcement Banner',
      items: ['Admin can now publish a live banner on the home page from Suggestions & Announcement → Announcement tab. Four styles (Info · Sale · Closed · Warning), one-toggle live/off, with a live preview before publishing. Perfect for "Closed for Eid" or "20% off cases this week".']
    },
    {
      date: 'Aug 2026',
      title: 'Weather Pill',
      items: ['Live Rotterdam weather chip in the home-page header — current temperature and icon (sun, cloud, rain, snow) that refresh every 15 minutes. Powered by Open-Meteo, no API key required.']
    },
    {
      date: 'Aug 2026',
      title: 'Full Bills History',
      items: ['The Bills tab now shows every past invoice from Jan 2025 to today (20+ months) in a scrollable month strip. Click any month to load and reprint that invoice with the correct dates, invoice number and PAID / DUE / UPCOMING stamp.']
    },
    {
      date: 'Aug 2026',
      title: 'Cleaner Admin Portal',
      items: ['Reduced button clutter: Bills + Expenses merged into a single Finances hub (two tabs inside). Warranty Card + Tax Form + Inventory buttons removed from the top-level admin — they now live inside Register where staff actually need them.']
    },
    {
      date: 'Aug 2026',
      title: 'Tax Form (Dutch BTW Invoice)',
      items: ['New Tax Invoice inside Register — enter the base price (excl. BTW), qty defaults to 1, BTW 21% is added on top and the total updates live per line. Prints with A Shop identity, KVK 68280939 and BTW NL002355010B65 on a beautiful blue-themed invoice.']
    },
    {
      date: 'Aug 2026',
      title: 'Rotating Ticker Partners',
      items: ['The orange left-label on the currency ticker now cycles through Western Union → Ria → Fidur every 2.2 seconds so all three money-transfer partners get equal visibility.']
    },
    {
      date: 'Aug 2026',
      title: 'Warranty Card',
      items: ['New Warranty Card tab in Register — fill in Customer, Mobile Price, Model & IMEI, SIM Lock and Date, then print a professional 1-year warranty card with real Samsung / Mi / Redmi logos. Only the stamp box stays blank on the printout. Terms cover software only — no physical or water damage liability.']
    },
    {
      date: 'Aug 2026',
      title: 'Money Transfer Circle on Home',
      items: ['Right side of the hero shows a rotating circle featuring Western Union, Ria and Fidur one-by-one — same rhythm as the multi-language greeting on the left.']
    },
    {
      date: 'Aug 2026',
      title: 'Bank Details on Bills',
      items: ['Invoice now shows a Payment Details section with Chase Bank, Beneficiary Pindi Inc, Account 978764298 and Routing 021000021. The details are stored in one place used by both the on-screen card and the printout.']
    },
    {
      date: 'Aug 2026',
      title: 'Register History (24 h)',
      items: ['History tab in Register shows every sale from the last 24 hours with sale number, time, payment method, items and total — plus a Reprint receipt button. Sales older than 24 hours are auto-purged so the list stays clean.']
    },
    {
      date: 'Aug 2026',
      title: 'Single Currency Rate',
      items: ['Removed the confusing Buy / Sell columns — every currency now shows one send rate with a small ▲/▼ arrow when it changes. The "WU" prefix was removed from the ticker chips; just the rate is shown.']
    },
    {
      date: 'Aug 2026',
      title: 'Invoice Print Restyled',
      items: ['The Print Invoice button now produces a properly styled invoice (gradient header, coloured line-item table, indigo totals, status stamp) instead of a plain black-and-white page. Colours survive the printer.']
    },
    {
      date: 'Aug 2026',
      title: 'Welcome on Matrix Loader',
      items: ['Removed the pop-up welcome modal. The "Welcome Back, Shahbaz Baig" message now appears on the Matrix login loader between the ASHOP logo and the status lines with a sky-to-emerald gradient.']
    },
    {
      date: 'Aug 2026',
      title: 'Since 2016 (year fix)',
      items: ['Corrected the "Since 2020" mentions on the home page to "Since 2016" in both the stats strip and the trust strip.']
    },
    {
      date: 'Aug 2026',
      title: 'Quick Sale Buttons',
      items: ['Register now has one-tap Quick Sale items — Print A4 B&W (€1), Print A4 Color (€1.50), Photocopy, Lamination, Scan. Tap Edit to add your own custom quick items or delete existing ones. Your list is saved locally.']
    },
    {
      date: 'Aug 2026',
      title: 'Lock Register for iPad',
      items: ['Lock Page button on the Register keeps the iPad/screen stuck on the POS — Back to Admin and Inventory buttons hide, and you need the admin PIN (0300) to unlock. Lock survives page reloads.']
    },
    {
      date: 'Aug 2026',
      title: 'Real Cash Register with Keypad',
      items: ['Register now works like a real POS — big numeric keypad, quick +€1/+€5/+€10/+€20 buttons, type any custom amount (like "Print A4 x5 — €5"), and cash or card checkout. Products still work with one tap.']
    },
    {
      date: 'Aug 2026',
      title: 'Printable Receipts (EN + NL)',
      items: ['After every sale, "Print Receipt" opens a modal to pick English or Nederlands. Prints a proper thermal-printer-sized receipt with shop name, address, phone, items, total, payment method and a "thank you" message.']
    },
    {
      date: 'Aug 2026',
      title: 'Shop, Register & Inventory',
      items: ['New "Shop" button on home page shows in-store products to customers. Admins get "Register" (cash register / POS) and "Inventory" buttons to manage stock, prices, photos, and toggle which items appear on the customer shop.']
    },
    {
      date: 'Aug 2026',
      title: 'Faster Forex Ticker',
      items: ['Ticker now scrolls at 4× the original speed (15 seconds per loop). Still pauses on hover.']
    },
    {
      date: 'Aug 2026',
      title: 'Currency USA & Custom Additions',
      items: ['USD added to the default list. You can now add or delete any currency from the admin currency page.']
    },
    {
      date: 'Aug 2026',
      title: 'Live Forex Ticker',
      items: ['New scrolling ticker on the home page shows real-time EUR → PKR, INR, BDT, TRY, MAD, PLN and 9 more currencies with buy/sell rates and up/down arrows showing daily changes.']
    },
    {
      date: 'Aug 2026',
      title: 'Currency Rate Manager',
      items: ['New "Currency" button in admin dashboard — set buy/sell rates manually for each country. Rates persist until you update them. Ticker automatically shows arrow indicators (▲/▼) based on your previous values.']
    },
    {
      date: 'Aug 2026',
      title: 'Printing Services Admin Page',
      items: ['New "Printing Services" button on the admin dashboard — see every print inquiry customers submit, view uploaded files, change status, WhatsApp customer with one tap.']
    },
    {
      date: 'Aug 2026',
      title: 'Print Services Live',
      items: ['Documents, Photocopies, Lamination and Scanning are open for orders. Passport photos, binding, business cards, posters, fax and custom prints (T-shirts, mugs) coming soon.']
    },
    {
      date: 'Aug 2026',
      title: 'Print Pricing Set',
      items: ['€1 per page for B&W, €1.50 per page for color. Lamination €2.50, scanning €0.50. Final price confirmed before printing.']
    },
    {
      date: 'Aug 2026',
      title: 'Ashop Print Services',
      items: ['New "Print" button on the home page — upload documents, choose color/size/binding, pick pickup or delivery, and pay in store. Or send everything via WhatsApp with one tap.']
    },
    {
      date: 'Aug 2026',
      title: 'Mobile App Preview',
      items: ['New "App" button on the home page — preview page with beautiful phone mockups showing the upcoming Ashop mobile app.']
    },
    {
      date: 'May 2026',
      title: 'Live Analog Clock',
      items: ['New analog clock with "Ashop" logo inside, sitting right above the Lock Page button — Rotterdam time, always ticking']
    },
    {
      date: 'May 2026',
      title: 'Bill & Expense Tracker',
      items: ['New "Expenses" page — snap a photo of any receipt and type the amount. Done.']
    },
    {
      date: 'May 2026',
      title: 'Expense Categories',
      items: ['Sort bills by Rent, Utilities, Supplies, Fuel, Internet, Software, or Other for easier tax filing']
    },
    {
      date: 'May 2026',
      title: 'Monthly Expense Totals',
      items: ['Running total at the top of the Expenses page — switch year/month to see what you spent']
    },
    {
      date: 'May 2026',
      title: 'Receipt Photo Storage',
      items: ['Receipt photos are uploaded and stored securely — tap any thumbnail to view the full image']
    },
    {
      date: 'May 2026',
      title: 'Smart Counter Reset',
      items: ['You can now set the counter to any number you want — just type it in and hit Set']
    },
    {
      date: 'May 2026',
      title: 'Auto-Skip Box Numbers',
      items: ['When scanning new packages, the system automatically skips any box numbers still in use by active packages']
    },
    {
      date: 'May 2026',
      title: 'Safe Cleanup',
      items: ['Reset now only deletes picked-up packages — active packages are never deleted or changed']
    },
    {
      date: 'May 2026',
      title: 'Automatic Data Backup',
      items: ['Your package data is now backed up every 12 hours automatically so you never lose anything']
    },
    {
      date: 'May 2026',
      title: 'Offline Access',
      items: ['You can now download and print your data even when the website is down']
    },
    {
      date: 'May 2026',
      title: 'CSV Export Page',
      items: ['New "Export" button lets you download all package lists as spreadsheet files']
    },
    {
      date: 'May 2026',
      title: 'Backup Now Button',
      items: ['Manual backup button on the Export page so you can save a fresh copy anytime']
    },
    {
      date: 'May 2026',
      title: 'JWT Login Security',
      items: ['Admin login now uses secure tokens - your session is verified on every action']
    },
    {
      date: 'May 2026',
      title: 'Password Moved to Server',
      items: ['Admin password is no longer visible in the website code - fully hidden on the server']
    },
    {
      date: 'May 2026',
      title: 'PIN Moved to Server',
      items: ['The management PIN code is now verified by the server, not the browser']
    },
    {
      date: 'May 2026',
      title: 'CORS Lockdown',
      items: ['Only ashoprotterdam.com can talk to our server now - no other websites allowed']
    },
    {
      date: 'May 2026',
      title: 'Protected Admin Endpoints',
      items: ['Delete, reset, and sensitive actions now require a valid login token to work']
    },
    {
      date: 'May 2026',
      title: 'Bills Page',
      items: ['New "Bills" page showing monthly costs from Pindi Inc with all subscriptions']
    },
    {
      date: 'May 2026',
      title: 'Print Invoice',
      items: ['Print button on the Bills page to get a clean paper copy of your monthly invoice']
    },
    {
      date: 'May 2026',
      title: 'Microsoft Azure Added to Invoice',
      items: ['OCR scanning subscription ($29.99/mo) now appears on the monthly invoice']
    },
    {
      date: 'May 2026',
      title: 'Confetti Celebration',
      items: ['Confetti pops on screen when a package gets picked up']
    },
    {
      date: 'May 2026',
      title: 'Sound Effects',
      items: ['Ding sound when adding a package, chime on pickup, pop on delete']
    },
    {
      date: 'May 2026',
      title: 'Counter Animation',
      items: ['Dashboard numbers now count up with a smooth animation instead of just appearing']
    },
    {
      date: 'May 2026',
      title: 'Card Animations',
      items: ['Package cards fade in smoothly when the list loads']
    },
    {
      date: 'May 2026',
      title: 'Cartoon Characters',
      items: ['6 new characters: Boxy, Speedy, Stella, Scannie, Checky, and Noti']
    },
    {
      date: 'May 2026',
      title: 'Boxy Popup',
      items: ['Boxy the happy package pops up when you add a new package']
    },
    {
      date: 'May 2026',
      title: 'Checky Popup',
      items: ['Checky the green checkmark appears when a pickup is confirmed']
    },
    {
      date: 'May 2026',
      title: 'Noti Popup',
      items: ['Noti the bell character shows up when a new customer notification arrives']
    },
    {
      date: 'May 2026',
      title: 'Stella on Rating Screen',
      items: ['Stella the star character appears on the customer rating popup']
    },
    {
      date: 'May 2026',
      title: 'Customer Star Ratings',
      items: ['Customers can now rate their experience 1 to 5 stars after requesting pickup']
    },
    {
      date: 'May 2026',
      title: 'Rating Comments',
      items: ['Customers can leave an optional comment with their star rating']
    },
    {
      date: 'May 2026',
      title: 'Ratings on Admin Dashboard',
      items: ['Admin can see average rating, total reviews, and star breakdown chart']
    },
    {
      date: 'May 2026',
      title: 'Google Review Removed',
      items: ['Removed the Google review popup - our own rating system is enough']
    },
    {
      date: 'May 2026',
      title: 'Delete All Packages Fixed',
      items: ['The "Delete all packages" button in Reset Counter now works properly']
    },
    {
      date: 'May 2026',
      title: 'Reset Counter Fixed',
      items: ['Reset counter now properly resets box numbers back to #1']
    },
    {
      date: 'May 2026',
      title: 'Analytics Always Visible',
      items: ['Package Activity, Performance, Carrier, and Ratings cards are always shown on dashboard']
    },
    {
      date: 'November 2025',
      title: 'Rate Limiting',
      items: ['Website blocks anyone making too many requests to prevent attacks']
    },
    {
      date: 'November 2025',
      title: 'Input Protection',
      items: ['All text inputs are cleaned to prevent hackers from injecting bad code']
    },
    {
      date: 'November 2025',
      title: 'Audit Logging',
      items: ['We keep a record of who deletes or changes packages']
    },
    {
      date: 'November 2025',
      title: 'Marketing Consent Checkbox',
      items: ['Customers can choose to receive updates by checking a box']
    },
    {
      date: 'November 2025',
      title: 'Users Page',
      items: ['New admin page showing customers who opted in for marketing']
    },
    {
      date: 'November 2025',
      title: 'Auto-Archive Packages',
      items: ['Picked-up packages automatically move to history after 7 days']
    },
    {
      date: 'November 2025',
      title: 'Auto-Delete Old Packages',
      items: ['Archived packages are automatically deleted after 30 days']
    },
    {
      date: 'November 2025',
      title: 'Tab Counts Fixed',
      items: ['Total Scanned now shows the correct number of available packages']
    },
    {
      date: 'November 2025',
      title: 'Admin Navigation Redesign',
      items: ['New top bar with Home, Users, Updates, Bills, Export, and Logout buttons']
    },
    {
      date: 'November 2025',
      title: 'Auto-Scroll on Edit',
      items: ['When you click Edit on a package, the page scrolls up to the form automatically']
    },
    {
      date: 'November 2025',
      title: 'Carrier Name in Notification',
      items: ['Admin now sees the carrier (FedEx, UPS, etc.) in the pickup notification popup']
    },
    {
      date: 'November 2025',
      title: '3rd Party Pickup Improved',
      items: ['Two ways to do 3rd party pickup: auto-fill by box number or manual entry']
    },
    {
      date: 'November 2025',
      title: 'Bigger Notification Popup',
      items: ['Pickup notification popup is now bigger so you can see all the details clearly']
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6">
      <div className="max-w-5xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => navigate('/staff')}
          className="mb-4 inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 text-white font-semibold rounded-xl hover:from-gray-700 hover:to-gray-800 transition-all shadow-lg hover:shadow-xl"
        >
          <i className="fas fa-arrow-left"></i>
          <span>Back to Admin Portal</span>
        </button>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
          <div className="text-center">
            <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-star text-white text-4xl"></i>
            </div>
            <h1 className="text-4xl font-bold text-gray-800 mb-2">
              What's New!
            </h1>
            <p className="text-gray-600 text-lg">
              {updates.length} features & changes made — Simple updates you can understand
            </p>
          </div>
        </div>

        {/* Updates List */}
        <div className="space-y-6">
          {updates.map((update, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              {/* Date Badge */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-2xl font-bold text-gray-800">{update.title}</h2>
                <span className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold">
                  {update.date}
                </span>
              </div>

              {/* Update Items */}
              <ul className="space-y-3">
                {update.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
                      <i className="fas fa-check text-green-600 text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-lg leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Fun Footer */}
        <div className="mt-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl p-6 text-white text-center">
          <i className="fas fa-rocket text-4xl mb-3"></i>
          <h3 className="text-2xl font-bold mb-2">We're Getting Better Every Day!</h3>
          <p className="text-lg opacity-90">
            More cool features coming soon! 🚀
          </p>
        </div>
      </div>
    </div>
  );
};

export default Updates;
